import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FiltroRicercaSoggettoDTO } from "@app/shared/dto/anagrafe/filtro-ricerca-soggettoDTO";
import { SoggettoRicercaDTO } from "@app/shared/dto/anagrafe/soggetto-ricercaDTO";
import { SiNoEnum } from "@app/shared/enum/si-no-enum";
import { TipoEntitaAnagrafeEnum } from "@app/shared/enum/tipo-entita-anagrafe-enum";
import { TipoFormEnum } from "@app/shared/enum/tipo-form.enum";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { FascicoloHelper } from "@app/shared/helper/fascicolo.helper";
import { AnagrafeService } from "@app/shared/services/anagrafe.service";
import { CampoSpecificoFascicolazioneVO } from "@app/shared/vo/campo-specifico-fascicolazioneVO";
import { TypeaheadMatch } from "ngx-bootstrap";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

@Component({
  selector: "app-valore-campo-specifico-esterno",
  templateUrl: "./valore-campo-specifico-esterno.component.html",
})
export class ValoreCampoSpecificoEsternoComponent implements OnInit {
  @Input()
  campo: CampoSpecificoFascicolazioneVO;
  
  @Input()
  valore: string;
  @Input()
  tipoForm: TipoFormEnum;
 
  @Input()
  ultimo: boolean;
  @Output()
  emitAggiungiNuovo: EventEmitter<string> = new EventEmitter();
  @Output()
  emitValore: EventEmitter<string> = new EventEmitter();
  @Output()
  emitRimuovi: EventEmitter<string> = new EventEmitter();
  valoreDigitato: string;
  digitazioneTerminata: boolean = false;
  listaAnagrafe: Observable<any>;
  filtroRicerca: string;

  public asyncSelected: string;
  public typeaheadLoading: boolean;
  public typeaheadNoResults: boolean;
  public valoreBool: boolean = false;
  filtro: FiltroRicercaSoggettoDTO;

  constructor(private anagrafeService: AnagrafeService) {
    this.filtro = new FiltroRicercaSoggettoDTO();
    this.filtro.filtroRicerca = new SoggettoRicercaDTO();

    this.listaAnagrafe = Observable.create((observer: any) => {
      // Runs on every search
      observer.next(this.asyncSelected);
    }).pipe(
      switchMap((token: string) =>
        this.anagrafeService.ricercaSoggetti(this.filtro, FascicoloHelper.getTipoAnagraficaCampo(this.campo).toString())
      )
    );
  }
  ngOnInit() {
    if (this.valore) {
      this.filtro.filtroTesto = this.valore;
      this.valoreDigitato =  this.valore;
    }
  }

  aggiungiNuovoValore() {
    this.emitAggiungiNuovo.emit();
    if (this.tipoForm === TipoFormEnum.MODIFICA) {
      this.digitazioneTerminata = true;
    } else {
      this.digitazioneTerminata = false;
    }
  }

  rimuovi() {
    this.emitRimuovi.emit();
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    this.valoreDigitato = e.item;
    this.digitazioneTerminata = true;
    this.emitValore.emit(this.valoreDigitato);
  }

  getDisabledPlus() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.ultimo) {
          return false;
        } else {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE:
        if (this.digitazioneTerminata) {
          return false;
        } else {
          return true;
        }
    }
  }

  getPlusVisible() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
       
          if (this.campo.ripetibile  === SiNoEnum.SI && this.valoreDigitato) {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE:
        if (this.campo.ripetibile  === SiNoEnum.SI && this.valoreDigitato) {
          return true;
        }
    }
    return false;
  }

  getMinusVisible() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.valoreDigitato) {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE:
        if (this.valoreDigitato) {
          return true;
        }
    }

    return false;
  }

  public changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  public changeTypeaheadNoResults(e: boolean): void {
    this.valoreBool = true;
    this.typeaheadNoResults = e;
  }
}
